import {ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, signal} from '@angular/core'
import {takeUntilDestroyed} from '@angular/core/rxjs-interop'
import {NavigationStart, Router, RoutesRecognized} from '@angular/router'
import {Store} from '@ngrx/store'
import {combineLatest} from 'rxjs'
import {filter} from 'rxjs/operators'
import {getSplashSelector} from '@core/store/core.selectors'
import {FadeComponent} from '../fade/fade.component'

@Component({
  selector: 'app-splash',
  imports: [FadeComponent],
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SplashComponent implements OnInit {
  readonly #destroyRef = inject(DestroyRef)
  readonly #store = inject(Store)
  readonly #router = inject(Router)

  show = signal(true)

  ngOnInit() {
    combineLatest([
      this.#router.events.pipe(filter(event => event instanceof NavigationStart || event instanceof RoutesRecognized)),
      this.#store.select(getSplashSelector),
    ])
      .pipe(takeUntilDestroyed(this.#destroyRef))
      .subscribe(([{url}, res]: [any, boolean]) => {
        if (url.includes('/home') || url === '/') {
          this.show.set(res)
        } else {
          this.show.set(false)
        }
      })
  }
}
